import Dexie, { type Table } from 'dexie';

class CashPulseDB extends Dexie {
  foyers!: Table;
  blocks!: Table;
  domains!: Table;
  categories!: Table;
  lines!: Table;
  objectives!: Table;
  scenarios!: Table;
  budgetSnapshots!: Table;
  patrimoineLines!: Table;
  patrimoineCategories!: Table;
  patrimoineSnapshots!: Table;
  kpiThresholds!: Table;

  constructor() {
    super('cashpulse');
    this.version(1).stores({
      foyers: 'id',
      blocks: 'id, foyerId',
      domains: 'id, foyerId, blockId',
      categories: 'id, foyerId, domainId',
      lines: 'id, foyerId, parentId',
      objectives: 'id, foyerId',
      scenarios: 'id, foyerId',
      budgetSnapshots: 'id, foyerId, timestamp',
      patrimoineLines: 'id, foyerId, categoryId',
      patrimoineCategories: 'id, foyerId',
      patrimoineSnapshots: 'id, foyerId, date',
      kpiThresholds: 'foyerId',
    });
  }
}

export const db = new CashPulseDB();
